import { useQuery } from '@tanstack/react-query';
import apiClient from '../../../../api/apiConfig';
import { UserType } from './types';

const getUserUrl = 'csb/users/all';

export const useGetUsers = () => {
  return useQuery<UserType>({
    queryFn: async () => {
      const response = await apiClient.get<UserType>(getUserUrl);
      return response.data;
    },
    queryKey: ['users'],
  });
};
